import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import { StatusResponse } from '../component/entry-form/StatusResponse';
import { useParams } from 'react-router-dom';
import BlankCard from "src/components/era-package/shared/BlankCard";

// const fullTitle = 'Entry Summary Status';
// const shortTitle = 'Status';

function SubmissionResponsePage(props) {
  const { id } = useParams()
  // const BCrumb = [
  //   { title: "ABI" },
  //   { title: "Entry Summary", to: pathMap.ABI_ENTRY_SUMMARY_LIST_VIEW },
  //   { title: "Edit", to: generatePath(pathMap.ABI_ENTRY_SUMMARY_EDIT_VIEW, { id }) },
  //   { title: shortTitle, },
  // ];

  return (
    <ScopedCssBaseline>
      <BlankCard>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
            p: 3
          }}
        >
          <StatusResponse basic id={id} displayBtn={true} />
        </Box>
      </BlankCard>
    </ScopedCssBaseline>);
};

export default SubmissionResponsePage;